module.exports = __webpack_public_path__ + "static/media/image3.9fe8bc5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image3.jpg
// module id = 1091
// module chunks = 0